module.exports = __webpack_public_path__ + "img/5C.805ef815.jpeg";